import React, { useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { shareTiktok } from 'src/app/shared/share/tiktok';

import type { ShareActionComponentPropsWithOptions } from '../types';

import { useTiktokEducationModal } from './useEducationModal';

// TODO migrate to new DS modal component
export const TiktokShare: React.FC<ShareActionComponentPropsWithOptions> = ({
	children,
	options,
	onAfterAction,
	onBeforeAction,
}) => {
	const openEducationModal = useTiktokEducationModal();
	const track = useTracking();
	const utilityContext = useUtilityContext();

	const onClick = useMemo(() => {
		return () => {
			void (async () => {
				await onBeforeAction?.();
				const {
					url,
					content: { image },
					trackingData,
					trackingEventName,
					config: { isSunriseEnabled },
				} = options;
				const success = await shareTiktok(
					{ url, image },
					{
						trackingData,
						trackingEvents: {
							success: trackingEventName,
							intent: 'tiktok_share_modal_view',
							continue: 'tiktok_share_modal_continue',
							cancel: 'tiktok_share_modal_close',
							failure: `${trackingEventName}_failure`,
						},
						openTiktokEducationModal: ({ onContinueAction }) =>
							openEducationModal({ isSunriseEnabled: !!isSunriseEnabled, onContinueAction }),
					},
					track,
					utilityContext,
				);
				await onAfterAction?.(success);
			})();
		};
	}, [onBeforeAction, onAfterAction, options, openEducationModal, track, utilityContext]);

	return React.cloneElement(children, {
		...children.props,
		onClick,
	});
};
